import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DATE_RANGES = [
  { label: '7D', value: '7d' },
  { label: '30D', value: '30d' },
  { label: '90D', value: '90d' },
  { label: '6M', value: '6m' },
  { label: '1Y', value: '1y' },
];

const CAMPAIGN_TYPES = [
  { label: 'All Types', value: 'all' },
  { label: 'Purchase', value: 'purchase' },
  { label: 'Referral', value: 'referral' },
  { label: 'Bonus', value: 'bonus' },
];

const AnalyticsFilterBar = ({ dateRange, onDateRangeChange, campaignType, onCampaignTypeChange, onRefresh, loading }) => {
  const [showCampaignDropdown, setShowCampaignDropdown] = useState(false);

  const selectedCampaign = CAMPAIGN_TYPES?.find(c => c?.value === campaignType) || CAMPAIGN_TYPES?.[0];

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Date Range Pills */}
      <div className="flex items-center gap-1 bg-muted/50 rounded-lg p-1">
        {DATE_RANGES?.map(range => (
          <button
            key={range?.value}
            onClick={() => onDateRangeChange?.(range?.value)}
            className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
              dateRange === range?.value
                ? 'bg-primary text-white shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
          >
            {range?.label}
          </button>
        ))}
      </div>

      {/* Campaign Type Dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowCampaignDropdown(!showCampaignDropdown)}
          className="flex items-center gap-2 px-3 py-2 bg-muted/50 hover:bg-muted rounded-lg text-xs font-medium text-foreground transition-colors border border-border"
        >
          <Icon name="Filter" size={13} className="text-muted-foreground" />
          {selectedCampaign?.label}
          <Icon name="ChevronDown" size={13} className="text-muted-foreground" />
        </button>
        {showCampaignDropdown && (
          <div className="absolute top-full left-0 mt-1 w-40 bg-card border border-border rounded-lg shadow-lg z-20 overflow-hidden">
            {CAMPAIGN_TYPES?.map(type => (
              <button
                key={type?.value}
                onClick={() => {
                  onCampaignTypeChange?.(type?.value);
                  setShowCampaignDropdown(false);
                }}
                className={`w-full text-left px-3 py-2 text-xs transition-colors ${
                  campaignType === type?.value
                    ? 'bg-primary/10 text-primary font-medium' :'text-foreground hover:bg-muted'
                }`}
              >
                {type?.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Refresh Button */}
      <button
        onClick={onRefresh}
        disabled={loading}
        className="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-primary hover:text-primary/80 bg-primary/10 hover:bg-primary/15 rounded-lg transition-colors disabled:opacity-50"
      >
        <Icon name="RefreshCw" size={13} className={loading ? 'animate-spin' : ''} />
        Refresh
      </button>
    </div>
  );
};

export default AnalyticsFilterBar;
